import { DecimalPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input, ViewEncapsulation } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { SonaIconComponent } from '../icon/public-api';
import { SonaRatingColorDirective } from '../rating-color/public-api';
import { SonaSpinnerComponent } from '../spinner/public-api';

/**
 * Represents the type of device
 */
enum DeviceType {
    /**
     * Represents a mobile device
     */
    MOBILE = 'mobile',

    /**
     * Represents a desktop device
     */
    DESKTOP = 'desktop'
}

type AnyDeviceType = DeviceType | 'crossDevice';

/**
 * Represents the state of a scan.
 */
enum ScanStatus {
    /**
     * Indicates that the scan is currently running and no results are available yet.
     */
    PENDING = 'pending',

    /**
     * Indicates the scan has been finished and results are available.
     */
    FINISHED = 'finished',

    /**
     * Indicates the scan has errored and no results are available.
     */
    ERROR = 'error',

    /**
     * Indicates the scan has been aborted by the user and no results are available.
     */
    ABORTED = 'aborted'
}

type ScanStatusType = `${ScanStatus}`;

@Component({
    selector: 'sona-scan-state',
    imports: [
        SonaIconComponent,
        SonaRatingColorDirective,
        SonaSpinnerComponent,
        DecimalPipe,
        TranslateModule
    ],
    templateUrl: './scan-state.component.html',
    styleUrl: './scan-state.component.scss',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SonaScanStateComponent {
    readonly state = input.required<ScanStatusType>();
    readonly score = input<number>();
    readonly deviceType = input<AnyDeviceType>();

    readonly deviceTypeIcon = computed(() => {
        const type = this.deviceType();
        switch (type) {
            case 'desktop':
                return 'desktop';
            case 'mobile':
                return 'device-mobile-camera';
            default:
                return null;
        }
    });
}
